import Vue from '@/app'
import commonApi from './apis'
import getResponse from 'fe-coms/utils/response'

const vm = new Vue()

async function getDigits (state) {
  if (state.isFetching) {
    const api = commonApi.digits
    const data = await getResponse(vm.$http(api.type, api.url, {}), {
      loadingOptions: true
    })
    if (data.isOk) {
      state.unitPriceDigits = data.content.unitPriceBit
      state.totalPriceDigits = data.content.totalPriceBit
      state.numberDigits = data.content.unitNumber
      state.isFetching = true
    } else {
      state.isFetching = false
    }
  }
}
export default {
  unitPriceDigits: (state) =>  {
    if (state.unitPriceDigits === undefined && !state.isFetching) {
      getDigits(state)
    }
    return state.unitPriceDigits
  },
  totalPriceDigits: (state) => {
    if (state.totalPriceDigits === undefined && !state.isFetching) {
      getDigits(state)
    }
    return state.totalPriceDigits
  },
  numberDigits: (state) => {
    if (state.numberDigits === undefined && !state.isFetching) {
      getDigits(state)
    }
    return state.numberDigits
  }
}
